import { render, staticRenderFns } from "./payment-countdown.vue?vue&type=template&id=64a88a44&scoped=true"
import script from "./payment-countdown.vue?vue&type=script&lang=js"
export * from "./payment-countdown.vue?vue&type=script&lang=js"
import style0 from "./payment-countdown.vue?vue&type=style&index=0&id=64a88a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a88a44",
  null
  
)

export default component.exports